<template>
  <div>
    <p class="text-h6 text-md-h4 text-center pt-4">Отзывы клиентов</p>
    <v-container class="pa-4">
      <v-row class="fill-height" align="center" justify="center">
        <template v-for="(item, i) in reviewes">
          <v-col :key="i" cols="12" md="4">
            <v-hover v-slot="{ hover }">
              <v-card
                class="mx-auto slide-up2"
                :id="item.forId"
                :elevation="hover ? 12 : 2"
                max-width="400"
              >
                <v-card-text class="text-h5 font-weight-bold">{{
                  item.text
                }}</v-card-text>
                <v-card-actions>
                  <v-list-item class="grow">
                    <v-list-item-avatar color="grey darken-3">
                      <v-img
                        class="elevation-6"
                        alt=""
                        :src="getImgUrl(item.avatar)"
                      ></v-img>
                    </v-list-item-avatar>

                    <v-list-item-content>
                      <v-list-item-title
                        >{{ item.name }} {{ item.age }}</v-list-item-title
                      >
                    </v-list-item-content>
                  </v-list-item>
                </v-card-actions>
              </v-card>
            </v-hover>
          </v-col>
        </template>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import { gsap } from "gsap";

export default {
  data: () => ({
    reviewes: [
      {
        forId: "first",
        text: '"За 3 года в Кубите я узнал как создавать сайты, понял в каком направлении двигаться и приобрел новых друзей."',
        img: "",
        name: "Савелий Шутов",
        age: "15 лет",
        avatar:"saveliy.webp"
      },
      {
        forId: "second",
        text: '"Опытные и добрые преподаватели. Всё по полочкам. Дружная компания. Хорошее оборудование."',
        img: "",
        name: "Григорий Дзюин",
        age: "15 лет",
        avatar:"grisha.webp"
      },
    ],
  }),
    methods: {
    getImgUrl(pic) {
      return require("../assets/images/" + pic);
    },
  },
  mounted() {
    gsap.from("#first", {
      scrollTrigger: {
        trigger: "#first",
        start: "top bottom-=200px",
        once: true,
        toggleActions: "restart none none pause",
      },
      x: -200,
      duration: 1,
    });
    gsap.from("#second", {
      scrollTrigger: {
        trigger: "#second",
        start: "top bottom-=200px",
        once: true,
        toggleActions: "restart none none pause",
      },
      x: 200,
      duration: 1,
    });
  },
};
</script>

<style>
</style>